/* Modulo: Video Reviews — multi-card slider + inline one-at-a-time video. Vanilla, no deps. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function initSection(root) {
    if (!root || root.__vrvInit) return;
    var track = root.querySelector('[data-vrv-track]');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-vrv-card]'));
    if (!cards.length) return;
    root.__vrvInit = true;

    var prevBtn = root.querySelector('[data-vrv-prev]');
    var nextBtn = root.querySelector('[data-vrv-next]');
    var index = 0;

    /* ─── Slider ─── */
    function gap() { return parseFloat(getComputedStyle(track).gap) || 0; }
    function getCpv() {
      var s = getComputedStyle(track), w = window.innerWidth, name = '--modulo-vrv-cpv';
      if (w <= 640) name = '--modulo-vrv-cpv-m';
      else if (w <= 1100) name = '--modulo-vrv-cpv-t';
      return parseFloat(s.getPropertyValue(name)) || parseFloat(s.getPropertyValue('--modulo-vrv-cpv')) || 4;
    }
    function maxIndex() { return Math.max(0, Math.ceil(cards.length - getCpv())); }
    function cardStep() { return cards[0].getBoundingClientRect().width + gap(); }
    function update() {
      track.style.transform = 'translate3d(' + (-cardStep() * index) + 'px,0,0)';
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= maxIndex();
    }
    function goTo(i) { index = Math.max(0, Math.min(maxIndex(), i)); update(); }

    /* ─── Inline video (one at a time) ─── */
    function setAria(card) {
      var pb = card.querySelector('[data-vrv-play]');
      if (pb) pb.setAttribute('aria-pressed', card.classList.contains('is-playing') ? 'true' : 'false');
    }
    function pauseAll(except) {
      for (var j = 0; j < cards.length; j++) {
        var c = cards[j];
        if (c === except) continue;
        var v = c.querySelector('video');
        if (v && !v.paused) v.pause();
        if (c.classList.contains('is-playing')) { c.classList.remove('is-playing'); setAria(c); }
      }
    }
    function swapEmbed(emb) {
      if (emb.__done) return; emb.__done = true;
      var f = document.createElement('iframe');
      f.src = emb.getAttribute('data-vrv-embed');
      f.setAttribute('allow', 'autoplay; fullscreen; encrypted-media; picture-in-picture');
      f.setAttribute('allowfullscreen', 'true');
      f.setAttribute('title', 'Video review');
      emb.appendChild(f);
    }
    function play(card) {
      pauseAll(card);
      var v = card.querySelector('video');
      if (v) {
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {});
      } else {
        var emb = card.querySelector('[data-vrv-embed]');
        if (emb) swapEmbed(emb);
      }
      card.classList.add('is-playing'); setAria(card);
    }
    function toggle(card) {
      var v = card.querySelector('video');
      if (v) {
        if (v.paused) play(card);
        else { v.pause(); card.classList.remove('is-playing'); setAria(card); }
      } else {
        var emb = card.querySelector('[data-vrv-embed]');
        if (emb && !emb.__done) play(card);
      }
    }

    /* ─── Swipe (with click guard) ─── */
    var sx = 0, sy = 0, drag = false, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      drag = true; moved = false; sx = e.clientX; sy = e.clientY;
    });
    track.addEventListener('pointermove', function (e) {
      if (drag && Math.abs(e.clientX - sx) > 8) moved = true;
    });
    window.addEventListener('pointerup', function (e) {
      if (!drag) return; drag = false;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) goTo(index + (dx < 0 ? 1 : -1));
    });
    track.addEventListener('pointercancel', function () { drag = false; });

    cards.forEach(function (card) {
      var media = card.querySelector('[data-vrv-media]');
      var pb = card.querySelector('[data-vrv-play]');
      if (media) media.addEventListener('click', function (e) {
        if (moved && e.detail !== 0) { moved = false; return; }  /* suppress click synthesized by a drag; let keyboard (detail 0) through */
        toggle(card);
      });
      if (pb) pb.addEventListener('click', function (e) { e.stopPropagation(); if (moved && e.detail !== 0) { moved = false; return; } toggle(card); });
    });

    /* ─── Arrows + keyboard ─── */
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { goTo(index - 1); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { goTo(index + 1); e.preventDefault(); }
    });

    /* ─── Pause when scrolled out of view ─── */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) {
        for (var k = 0; k < ents.length; k++) if (!ents[k].isIntersecting) pauseAll(null);
      }, { threshold: 0 });
      io.observe(root);
    }

    /* ─── Resize ─── */
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { if (index > maxIndex()) index = maxIndex(); update(); }, 120);
    });

    update();
  }

  function boot(scope) {
    var els = (scope || document).querySelectorAll('[data-vrv]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target || document); });
})();
